const createData = (data) => {
    return  Object.entries(data).map(([name, value]) => `\t"${name}" => "${value}"`).join(',\n')
}

const createHeader = (data) => {
    return  Object.entries(data).map(([name, value]) => `\t"${name}: ${value}"`).join(',\n')
}

export default (options) => {
    let curl = `
<?php

$curl = curl_init();

$headers = ;

$post = ;

curl_setopt_array($curl, [
  CURLOPT_URL,
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => "",
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 30,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST =>,
  CURLOPT_POSTFIELDS => $post,
  CURLOPT_HTTPHEADER => $headers,
]);

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);
`
    curl = curl.replace(/CURLOPT_URL/i, `CURLOPT_URL => "${options.url}"`)
    curl = curl.replace(/headers =/i, `headers = [\n${createHeader(options.headers)}\n]`)
    curl = curl.replace(/post =/i, `post = [\n${createData(options.data)}\n]`)
    curl = curl.replace(/CURLOPT_CUSTOMREQUEST =>/i, `CURLOPT_CUSTOMREQUEST => "${options.method.toUpperCase()}"`)
    return curl
}

